import Vue from 'vue';
import App from './App.vue';
// import appConfig from './config';
import JSSDK from '@zm-fe/zm-jssdk';
import router from './router';
import store from './store';
import http from './utils/http';
import track from '@utils/track';
import * as api from './api';
import * as utils from '@utils';
import 'amfe-flexible';
import './assets/css/g.scss';
import moment from 'moment';
import manifest from './utils/manifest';
import * as dd from 'dingtalk-jsapi';

import { geturlParams } from '@utils/index';

moment.locale('zh-cn');


// 一次性全部引入Vant时打开，默认不打开，省流量
// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);
// localStorage.clear();
// window.localStorage.setItem('dingdingAuth', '7edd14c5-5ad6-42ef-9143-79efa0ebe213');
// 只在非生产环境加载vconsole
if (process.env.VUE_APP_RUN_ENV !== 'prod' || geturlParams().vconsole === 'zmweb') { // 方便线上调试 不建议用
  const VConsole = require('vconsole');
  new VConsole();
}

// 禁用iOS Webview弹性效果
if (dd.env.platform !== 'notInDingTalk') dd.ui.webViewBounce.disable();

// 埋点配置
JSSDK.setConfig({
  // environment: 'fat',
  environment: process.env.VUE_APP_RUN_ENV,

  // debug模式, 可选值:error / debug。调试阶段，可以在console查看打印信息
  logLevel: 'error',

  // histroy模式
  history: true,

  // 对XMLHttpRequest异常自动上报
  interceptor: true,
});

// 处理缓存
if (process.env.VUE_APP_RUN_ENV !== 'dev') manifest();

track.setDefaults();

Vue.prototype.$sdk = JSSDK;

Vue.config.productionTip = false;

// 数据接口
Vue.prototype.$httpApi = api;

// http请求方法
Vue.prototype.$http = http;

// 工具方法
Vue.prototype.$utils = utils;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
